import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";

const PreLoader = () => {
  const preloaderRef = useRef(null);
  const headerRef = useRef(null);
  const tl = gsap.timeline({
    paused: true,
    onComplete: () => {
      gsap.to(preloaderRef.current, {
        duration: 1,
        y: "-100%",
        display: "none",
      });

      tl.from(
        headerRef.current,
        {
          duration: 1.5,
          y: "-150%",
        },
        "-=.2"
      );
      document.body.style.overflow = 'hidden auto';
    },
  });

  tl.to("#percent, #bar", {
    duration: 0.2,
    opacity: 0,
    zIndex: -1,
  });

  tl.to("#preloader", {
    duration: 0.8,
  });

  tl.to("#title", {
    duration: 0.5,
    y: "-100%",
  });

  tl.to("#bar", {
    duration: 1,
    width: "100%",
  }, "-=1");

  const move = () => {
    var width = 1;
    var barElement = document.getElementById("bar");
    var id = setInterval(frame, 10);
    function frame() {
      if (width >= 100) {
        clearInterval(id);
        tl.play();
      } else {
        width++;
        document.getElementById("percent").innerHTML = width + "%";
        gsap.to(barElement, {
          duration: 0.1,
          width: `${width}%`,
        });
      }
    }
  };
  
  useEffect(() => {
    // Hide scrollbar and prevent scrolling when component mounts
    document.body.style.overflow = 'hidden';
    move();
  }, []);

  return (
    <div ref={preloaderRef} id="preloader">
      <div id="bar" style={{ width:'0%', height: '5px', backgroundColor:'#9746E7'}}></div>
      <div ref={headerRef} id="title">
        HORUSCHILD.
      </div>
      <div id="percent"></div>
    </div>
  );
};

export default PreLoader;
